<div class="popover-arrow" *ngIf="isArrow"></div>

<ng-template ad-host></ng-template>
